module.exports = __webpack_public_path__ + "img/idea-score.cc930a45.svg";